import React from "react";
import { Redirect } from "react-router-dom";

import { withFirebaseAuth } from "js/react/views/Auth/FirebaseAuthContext";
import { LoadingPage } from "js/react/components/LoadingPage";
import ErrorMessage from "js/app/ErrorMessage";
import { serverContext } from "js/config";
import logger from "js/core/logger";
import { RemoveSplashScreen } from "js/editor/SplashScreen";

const log = logger.info(logger.AUTH).bind(logger);

class SsoConsume extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: serverContext.customToken ? "pending" : "failed"
        };
    }

    async componentDidMount() {
        RemoveSplashScreen(true);

        const { auth } = this.props;
        try {
            await signOutIfNeeded(auth);
            await auth.signInWithCustomToken(serverContext.customToken);
            this.setState({ status: "succeeded" });
        } catch (err) {
            this.setState({ status: "failed" });
        }
    }

    render() {
        switch (this.state.status) {
            case "pending":
                return (
                    <LoadingPage />
                );
            case "succeeded":
                return (
                    <Redirect to={serverContext.relayState || "/"} />
                );
            case "failed":
                return (
                    <ErrorMessage message={"Sorry, we could not authenticate you."} />
                );
        }
    }
}

async function signOutIfNeeded(auth) {
    // sign out of firebase
    if (auth.currentUser) {
        log("will sign out of firebase");
        await auth.signOut();
        log("did sign out of firebase");
    }
}

export default withFirebaseAuth(SsoConsume);
